export const GET_TEMPLATE_FIELDS = 'getTemplateFields';
